// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.3.2@css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-nav-menu[data-v-5dc72034]{background:#545c64;color:#fff;padding-left:40px;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:50px;line-height:50px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);
